import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref } from 'vue'
import { InputPresenca, IntencaoDePresenca, IPresenca } from 'common/types/Presenca'
import { alert, userModule } from '@/store'
import PresencaService from '@/services/PresencaService'
import { temGrauParaParticiparDoEvento, irmaoPodeParticiparDoEventoCasoSejaDeLoja } from '@/shareds/sharedsEvento'
import { IEvento } from 'common/types/Evento'
import DialogoDeCadastro from '@/components/auth/DialogoDeCadastro.vue'
import { dataEHoraDoEvento, eventoDeLoja } from '../../../common/shareds/sharedEvento'
import dayjs from 'dayjs'
import { usuarioPertenceALojaAtivo } from '../../../common/shareds/sharedLoja'
import { Fragment } from 'vue-fragment'
import DialogoDeConvidados from './DialogoDeConvidados.vue'
import { formatarConvidados } from '@/../common/shareds/sharedPresenca'


export default /*#__PURE__*/_defineComponent({
  __name: 'BotoesDePresenca',
  props: {
	value: { type: Object as PropType<InputPresenca>, required: true },
	evento: { type: Object as PropType<IEvento>, required: true },
},
  emits: ["input"],
  setup(__props, { emit }: { emit: ({
	(e: 'input', presenca: InputPresenca | IPresenca): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const presenca = computed(() => props.value)
const dialogoDeCadastro = ref<InstanceType<typeof DialogoDeCadastro>>()

const opcoesDePresenca: {
	text: string,
	icon: string,
	value: string | null,
	intencoes: IntencaoDePresenca[],
	classAtivo?: string,
}[] = [
	{
		text: 'Sessão',
		value: 'Sessão',
		intencoes: ['Sessão'],
		icon: 'mdi-gavel',
	},
	{
		text: 'Sessão e Ágape',
		value: 'Sessão e Ágape',
		intencoes: [ 'Sessão', 'Ágape'],
		icon: 'mdi-silverware-fork-knife',
	},
	{
		text: 'Não Irei',
		value: 'Não Vai',
		intencoes: [ 'Não Vai' ],
		icon: 'mdi-close',
		classAtivo: 'error darken-3'
	},
	{
		text: 'Desconfirmar',
		intencoes: [],
		value: null,
		icon: 'mdi-help',
	},
]

const confirmandoPresenca = ref<IntencaoDePresenca[] | false>(false)

const tipoAAtribuir = ref<string | null>(null)

const opcaoAtual = computed(() => opcoesDePresenca
	.find(({ intencoes }) =>
		intencoes.every(intencao => presenca.value.intencoes.includes(intencao)) &&
		presenca.value.intencoes.every(intencao => intencoes.includes(intencao)),
	) || null)

const tipoDeIntencao = computed({
	get: () => opcaoAtual.value?.value || null,
	set: (tipo: string | null) => {
		presenca.value.intencoes = tipoDeIntencao.value === tipo
			? []
			: opcoesDePresenca
				.find(opcao => opcao.value === tipo)?.intencoes ?? []
	},
})

const temGrauNecessario = computed(() => {
	if (!userModule.currentUser) return false
	if (userModule.currentUser.role === 'Visitante') return false
	return temGrauParaParticiparDoEvento(props.evento, userModule.currentUser)
})

const podeVerParticipacaoDoEvento = computed(() => {
	if (!userModule.currentUser) return false
	return temGrauNecessario.value ||
		userModule.currentUser.role === 'Visitante' ||
		!userModule.currentUser.configuracaoLimitada
})

const podeParticiparDoEventoCasoSejaDeLoja = computed(() => {
	if (!userModule.currentUser) return false
	return irmaoPodeParticiparDoEventoCasoSejaDeLoja(props.evento, userModule.currentUser)
})

const convidadosFormatados = computed(() => formatarConvidados(presenca.value.convidados))

async function trocarPresenca(tipo: string | null, confirmado?: boolean) {
	if (!userModule.currentUser) return
	if (
		tipo !== null && !confirmado && (
			userModule.currentUser.role === 'Visitante' ||
			!userModule.currentUser.configuracaoLimitada
		)
	) {
		dialogoDeCadastro.value?.mostrar(userModule.currentUser)
		tipoAAtribuir.value = tipo
		return
	}
	if (userModule.currentUser.role === 'Visitante') return
	if (!temGrauNecessario.value) {
		alert.setError('Você não tem grau necessário para participar')
		return
	}

	if (tipo === tipoDeIntencao.value) return
	const intencoes: IntencaoDePresenca[] = opcoesDePresenca
			.find(opcao => opcao.value === tipo)?.intencoes ?? []

	const tipoDeIntencaoAnterior = tipoDeIntencao.value
	try {
		confirmandoPresenca.value = intencoes
		const atualizacaoDaPresenca: InputPresenca = {
			...presenca.value,
			irmao: userModule.currentUser._id,
			intencoes,
			convidados: intencoes.includes('Ágape') ? presenca.value.convidados : { adultos: 0, criancas: 0 }
		}
		const novaPresenca = presenca.value._id
			? await PresencaService.put(presenca.value._id, atualizacaoDaPresenca)
			: await PresencaService.post(atualizacaoDaPresenca)
		emit('input', novaPresenca)
		if (
			!presenca.value.intencoes.includes('Ágape') &&
			intencoes.includes('Ágape') &&
			eventoDeLoja(props.evento) &&
			!usuarioPertenceALojaAtivo(userModule.currentUser, props.evento.entidade._id)
		) {
			const dataEHora = dataEHoraDoEvento(props.evento)
			const umDiaAntes = dayjs(dataEHora)
				.startOf('day')
				.subtract(1, 'day')

			if (dayjs().isAfter(umDiaAntes) && dayjs().isBefore(dataEHora)) {
				alert.setMessage({
					type: 'warning',
					text: 'Favor avisar o mestre de banquetes da loja',
					timeout: -1,
				})
			}
		}
	} catch (error) {
		alert.setError(error)
		tipoDeIntencao.value = tipoDeIntencaoAnterior
	} finally {
		confirmandoPresenca.value = false
	}
}

return { __sfc: true,props, emit, presenca, dialogoDeCadastro, opcoesDePresenca, confirmandoPresenca, tipoAAtribuir, opcaoAtual, tipoDeIntencao, temGrauNecessario, podeVerParticipacaoDoEvento, podeParticiparDoEventoCasoSejaDeLoja, convidadosFormatados, trocarPresenca, DialogoDeCadastro, Fragment, DialogoDeConvidados }
}

})